export default {
  namespaced: true,

  state: {
    isLoading: true,
    hasDetails: false,
    updateKey: 0,
    list: [],
    new: '',
    current: false,
  },

  mutations: {
    IS_LOADING(state, bool) {
      state.isLoading = bool;
    },

    HAS_DETAILS(state, bool) {
      state.hasDetails = bool;
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },

    SET(state, services) {
      state.list = services;
    },

    NEW(state, services) {
      state.new = services;
    },

    SET_CURRENT(state, instance) {
      state.current = instance;
    },
  },

  actions: {
    SET(context, services) {
      context.commit('SET', services);
    },
  }
}
